import * as React from "react"
// helper
import { ISvgIcons } from "./helper"

export const EyeOffIcon: React.FC<ISvgIcons> = ({
    className = "",
    ...rest
}) => (
    <svg
        viewBox="0 0 24 24"
        className={`${className}`}
        stroke="currentColor"
        strokeWidth={2}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        stroke-linecap="round"
        stroke-linejoin="round"
        {...rest}
    >
        <path d="M14.5299 9.46992L9.46992 14.5299C8.81992 13.8799 8.41992 12.9899 8.41992 11.9999C8.41992 10.0199 10.0199 8.41992 11.9999 8.41992C12.9899 8.41992 13.8799 8.81992 14.5299 9.46992Z" />
        <path d="M17.8201 5.76998C16.0701 4.44998 14.0701 3.72998 12.0001 3.72998C8.47009 3.72998 5.18009 5.80998 2.89009 9.40998C1.99009 10.82 1.99009 13.19 2.89009 14.6C3.68009 15.84 4.60009 16.91 5.60009 17.77" />
        <path d="M8.41992 19.5299C9.55992 20.0099 10.7699 20.2699 11.9999 20.2699C15.5299 20.2699 18.8199 18.1899 21.1099 14.5899C22.0099 13.1799 22.0099 10.8099 21.1099 9.39993C20.7799 8.87993 20.4199 8.38993 20.0499 7.92993" />
        <path d="M15.5099 12.7C15.2499 14.11 14.0999 15.26 12.6899 15.52" />
        <path d="M9.47 14.53L2 22" />
        <path d="M22 2L14.53 9.47" />
    </svg>
)
